import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { Search } from 'lucide-react';
import './recherche.css';
import '../accueil/familles-module.css';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const ouvrirRecherche = () => window.dispatchEvent(new CustomEvent('ouvrir-recherche'));

/* LOT 47 · section 6 · B · une recherche partout : Ctrl/⌘ + K sur ordinateur, la barre en haut de l'Accueil */
export const RechercheGlobale = () => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const [d, setD] = useState(null);
  const [i, setI] = useState(0);
  const navigate = useNavigate();
  const { tenantSlug } = useParams();
  const ref = useRef(null);
  const ouvert = useRef(false);
  ouvert.current = open;
  useEffect(() => {
    const k = (e) => { if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); setOpen(true); } if (e.key === 'Escape' && ouvert.current) { e.preventDefault(); e.stopPropagation(); setOpen(false); } };
    const o = () => setOpen(true);
    window.addEventListener('keydown', k, true); window.addEventListener('ouvrir-recherche', o);
    return () => { window.removeEventListener('keydown', k, true); window.removeEventListener('ouvrir-recherche', o); };
  }, []);
  useEffect(() => { if (open) setTimeout(() => ref.current?.focus(), 30); else { setQ(''); setD(null); } }, [open]);
  useEffect(() => {
    if (q.trim().length < 2) { setD(null); return undefined; }
    const t = setTimeout(() => axios.get(`${API}/recherche`, { params: { q }, withCredentials: true }).then((r) => { setD(r.data); setI(0); }).catch(() => setD({ groupes: [], erreur: true })), 300);
    return () => clearTimeout(t);
  }, [q]);
  if (!open) return null;
  const items = (d?.groupes || []).flatMap((g) => g.items.map((x) => ({ ...x, g: g.key })));
  const recents = (() => { try { return JSON.parse(localStorage.getItem('rg53-recents') || '[]'); } catch { return []; } })();
  const aller = (x) => { if (!x) return; try { localStorage.setItem('rg53-recents', JSON.stringify([q.trim(), ...recents.filter((r) => r !== q.trim())].filter((r) => r.length >= 2).slice(0, 5))); } catch { /* stockage indisponible */ } setOpen(false); navigate(`/${tenantSlug}/${x.to}`); };
  const clavier = (e) => {
    if (e.key === 'ArrowDown') { e.preventDefault(); setI((v) => Math.min(items.length - 1, v + 1)); }
    if (e.key === 'ArrowUp') { e.preventDefault(); setI((v) => Math.max(0, v - 1)); }
    if (e.key === 'Enter') aller(items[i]);
  };
  let n = -1;
  return (
    <div className="rg-fond" onMouseDown={(e) => e.target === e.currentTarget && setOpen(false)} data-testid="recherche-fond">
      <div className="rg" role="dialog" aria-label="Rechercher" data-testid="recherche">
        <label className="rg-in"><Search size={18} /><input ref={ref} value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={clavier} placeholder="Produit, plat, équipier, fournisseur, facture, ou un geste (« compter »)" data-testid="recherche-input" /><kbd>Échap</kbd></label>
        <div className="rg-res" data-testid="recherche-resultats">
          {q.trim().length < 2 ? (recents.length ? <div className="rg-g" data-testid="recherche-recents"><small>Dernières recherches</small>{recents.map((r) => <button key={r} type="button" className="rg-l" onClick={() => setQ(r)} data-testid={`recherche-recent-${r}`}><b>{r}</b></button>)}</div> : <p className="rg-vide">Tapez au moins 2 lettres.</p>)
            : !d ? <div className="ff-squelette"><i /><i /></div>
              : !items.length ? <p className="rg-vide" data-testid="recherche-aucun">Rien trouvé pour « {q} ».</p>
                : d.groupes.map((g) => <div key={g.key} className="rg-g"><small>{g.titre}</small>{g.items.map((x) => { n += 1; const j = n; return <button key={`${g.key}-${j}`} type="button" className={`rg-l${j === i ? ' is-on' : ''}`} onMouseEnter={() => setI(j)} onClick={() => aller(x)} data-testid={`recherche-${g.key}-${j}`}><b>{x.titre}</b>{x.sous && <span>{x.sous}</span>}</button>; })}</div>)}
        </div>
      </div>
    </div>
  );
};

export const BarreRecherche = ({ testId = 'accueil-recherche' }) => (
  <button type="button" className="rg-barre" onClick={ouvrirRecherche} data-testid={testId}><Search size={16} /><span>Chercher un produit, un plat, un équipier…</span><kbd>Ctrl K</kbd></button>
);
